import { createContext } from 'react';

const ProportionContext = createContext({
	proportion: 0,
});
export default ProportionContext;
